import { render, staticRenderFns } from "./mergeLogs.vue?vue&type=template&id=425875d8&scoped=true"
import script from "./mergeLogs.vue?vue&type=script&lang=ts"
export * from "./mergeLogs.vue?vue&type=script&lang=ts"
import style0 from "./mergeLogs.vue?vue&type=style&index=0&id=425875d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425875d8",
  null
  
)

export default component.exports